<div class="modal-body">
  <mat-card class="study-info">
    <div class="study-info-title-container">
      <mat-card-title class="d-flex">
        <span class="col">{{ deck?.name }}</span>
        <span class="d-flex ms-auto">{{ deck?.displayName }}</span>
      </mat-card-title>
      <mat-card-subtitle fxLayout.gt-xs="row" fxLayout.xs="column">
        {{ deck?.isFinishedForToday ? 'finished' : 'study' }}: {{ deck?.mode }} duration:{{ deck?.duration }} difficulty:{{ deck?.difficulty }}
        <span style="float:right;" [ngStyle]="{color: phaseColor }">{{ deck?.phase }} phase</span>
        <br />
        <span>review:&nbsp;{{ status?.reviewProgress }} / {{ status?.reviewTarget }}</span>
        <span style="float:right">studyTime:&nbsp;{{ sessionTime * 1000 | date: 'H:mm:ss':'UTC' }}</span>
        <br />
        <span>studied:&nbsp;{{ status?.acquisitionProgress }} / {{ status?.acquisitionTarget }}</span>
        <span style="float:right;visibility:hidden">maturity:&nbsp;{{ maturityProgress | percent }}</span>
        <br />
        @if (lastStatus.length > 0) {
          <span>
            previous card&nbsp;
            <span class="data" [style.color]="lastStatus.includes('repositioned') ? 'paleGreen' : 'inherit'">
              {{ lastStatus }}
            </span>
          </span>
        }
        <span class="studylog" style="float:right" (click)="onStudyLog()"><img loading="lazy" [style.filter]="'invert(1)'" src="{{download.src}}" alt="{{download.alt}}"/><span>studylog</span></span>
        <br />
        @if (currentStatus.length) {
          <span>current card&nbsp;
            <span class="data" [style.color]="'orange'">
              {{ currentStatus }}
            </span>
            <span>{{ gameplayStatus }}</span>
          </span>
        }
      </mat-card-subtitle>
    </div>
    <hr />
    <mat-card-content class="study-info-list-container noscrollbar">
      <mat-expansion-panel [hideToggle]="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            acquired today:
          </mat-panel-title>
          <mat-panel-description>
            {{ countTitle(acquiredIdsToday, 'card', 'cards')}}
          </mat-panel-description>
        </mat-expansion-panel-header>
        @for (id of (acquiredIdsToday); track $index) {
          <p class="data">{{ id }}</p>
        }
      </mat-expansion-panel>
      <hr />
      <mat-expansion-panel [hideToggle]="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            all cards:
          </mat-panel-title>
          <mat-panel-description>
            {{ countTitle(deck?.cards??[], 'card', 'cards')}}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div
          [hidden]="allCardSource.data.length === 0"
          class="elevated data p-0"
        >
          <table
            #allCards
            mat-table
            [dataSource]="allCardSource"
            matSort="allCardsSort"
            class="elevated data"
          >
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                name
              </th>
              <td mat-cell *matCellDef="let element">
                {{ shortName(element) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="score">
              <th mat-header-cell *matHeaderCellDef>
                Score
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.score | number: '1.0-2' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="maturity">
              <th mat-header-cell *matHeaderCellDef>
                Maturity
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.maturityPoints | number }}
              </td>
            </ng-container>

            <ng-container matColumnDef="responseTime">
              <th mat-header-cell *matHeaderCellDef>
                Response
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.responseTime | number }}
              </td>
            </ng-container>

            <ng-container matColumnDef="review">
              <th mat-header-cell *matHeaderCellDef>
                Review
              </th>
              <td mat-cell *matCellDef="let element">
                {{ reviewDue(element) | number: '1.0' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="gameplay">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Gameplay
              </th>
              <td mat-cell *matCellDef="let element">
                {{ gameplayType(element) }}
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns0; sticky: true"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns0"
              class="p-0"
              [ngClass]="{
                selected: selection.isSelected(row)
              }"
              (click)="selection.toggle(row)"
            ></tr>
          </table>

          <mat-paginator
            [length]="allCardSource.data.length"
            [pageSize]="50"
          >
          </mat-paginator>
        </div>
      </mat-expansion-panel>
      <hr />
      <mat-expansion-panel [hideToggle]="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            study order progress:
          </mat-panel-title>
          <mat-panel-description>
            finished: {{ finishedStudyOrdersCount }} remaining: {{ remainingStudyOrdersCount }}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-card-content [ngStyle]="{'overflow':'auto','max-height':'300px','max-width':'600px', 'width':'100%','margin':'0'}">
          <ngx-json-viewer [json]="studyOrderProgress"></ngx-json-viewer>
        </mat-card-content>
      </mat-expansion-panel>
      <hr />
      <div
        [hidden]="deckCardSource.data.length === 0"
        class="elevated"
      >
        <table
          #deckCards
          mat-table
          [dataSource]="deckCardSource"
          matSort="deckCardsSort" matSortActive="#" matSortDirection="asc" matSortDisableClear
          class="data"
        >
          <ng-container matColumnDef="#">
            <th mat-header-cell *matHeaderCellDef>
              #
            </th>
            <td mat-cell *matCellDef="let element">
              {{ findIndex(element) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
              id
            </th>
            <td mat-cell *matCellDef="let element">
              {{ shortName(element) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="score">
            <th mat-header-cell *matHeaderCellDef>
              Score
            </th>
            <td mat-cell *matCellDef="let element">
              {{ score(element) | number: '1.0-2' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="maturity">
            <th mat-header-cell *matHeaderCellDef>
              Maturity
            </th>
            <td mat-cell *matCellDef="let element">
              {{ maturity(element) | number }}
            </td>
          </ng-container>

          <ng-container matColumnDef="responseTime">
            <th mat-header-cell *matHeaderCellDef>
              Response
            </th>
            <td mat-cell *matCellDef="let element">
              {{ response(element) | number }}
            </td>
          </ng-container>

          <ng-container matColumnDef="review">
            <th mat-header-cell *matHeaderCellDef>
              Review
            </th>
            <td mat-cell *matCellDef="let element">
              {{ reviewDue(element) | number: '1.0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="assets">
            <th mat-header-cell *matHeaderCellDef>
              Assets
            </th>
            <td mat-cell *matCellDef="let element">
              {{ isAssetized(element) ? 'ok' : '??' }}
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="p-0"
            [ngClass]="{
              active: isActive(row),
              highlight: isRepositioned(row)
            }"
            (click)="show(row)"
          ></tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
  <nx-superprep-version [showLtVersion]="true"></nx-superprep-version>
</div>
